// hooks/useAuth.js
import { useSelector, useDispatch } from 'react-redux';
import { 
  signInWithEmail,
  signInWithGoogle,
  signInWithApple,
  signOutUser,
  clearError,
  checkAdmin  // 👈 ADD THIS
} from '../features/auth/authSlice';
import { useNavigate } from 'react-router-dom';

export const useAuth = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { 
    user, 
    profile, 
    isAuthenticated, 
    isAdmin,  // 👈 ADD THIS
    loading, 
    error,
    needsProfileSetup,
    authChecked 
  } = useSelector((state) => state.auth);

  // Navigate based on the thunk RESULT, not the render-time closure (which is stale
  // immediately after dispatch). New users stay put for profile setup.
  const routeAfterAuth = (result) => {
    if (result?.needsProfileSetup) return;
    navigate(result?.isAdmin ? '/admin' : '/dashboard');
  };

  const loginWithEmail = async (email, password) => {
    try {
      const result = await dispatch(signInWithEmail({ email, password })).unwrap();
      routeAfterAuth(result);
    } catch (err) {
      console.error('Login failed:', err);
      throw err;
    }
  };

  const loginWithGoogle = async () => {
    try {
      const result = await dispatch(signInWithGoogle()).unwrap();
      routeAfterAuth(result);
    } catch (err) {
      console.error('Google login failed:', err);
      throw err;
    }
  };

  const loginWithApple = async () => {
    try {
      const result = await dispatch(signInWithApple()).unwrap();
      routeAfterAuth(result);
    } catch (err) {
      console.error('Apple login failed:', err);
      throw err;
    }
  };

  const logout = async () => {
    try {
      await dispatch(signOutUser()).unwrap();
      navigate('/');
    } catch (err) {
      console.error('Logout failed:', err);
    }
  };

  // 👈 NEW: Manual admin check (useful for ProtectedRoute fallback)
  const verifyAdmin = async () => {
    try {
      const result = await dispatch(checkAdmin()).unwrap();
      return result;
    } catch (err) {
      return false;
    }
  };

  const clearAuthError = () => {
    dispatch(clearError());
  };

  return {
    user,
    profile,
    isAuthenticated,
    isAdmin,  // 👈 ADD THIS
    loading,
    error,
    needsProfileSetup,
    authChecked,
    loginWithEmail,
    loginWithGoogle,
    loginWithApple,
    logout,
    verifyAdmin,  // 👈 NEW
    clearError: clearAuthError,
  };
};
